<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>person</mat-icon>
        </button>
        <span>Nutzer auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">
        <div class="preview-entry-container">
            <div *ngFor="let user of users" class="preview-entry" (click)="userSelected(user)">
                <app-user-preview [user]="user"></app-user-preview>
            </div>
        </div>
    </div>
    
</div>